import React, {Suspense, lazy} from "react";
import ReactDOM from "react-dom";
import {Provider} from "react-redux";
import {Layout} from "./utility/context/Layout";
import * as serviceWorker from "./serviceWorker";
import {store} from "./redux/storeConfig/store";
import Spinner from "./components/@vuexy/spinner/Fallback-spinner";
import "./index.scss";
import 'react-dropzone-uploader/dist/styles.css'
import './assets/scss/custom.scss'
import 'react-toastify/dist/ReactToastify.css';
import 'react-input-range/lib/css/index.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import {persistStore} from "redux-persist";
import {PersistGate} from 'redux-persist/lib/integration/react';
import setAuthorizationToken from "./utils/setAuthorizationToken";
import {logout} from "./redux/actions/auth/loginActions";


const LazyApp = lazy(() => import("./App"));

if (localStorage.getItem('token')) {
  setAuthorizationToken(localStorage.getItem('token'));
  const currentTime = Date.now();
  if (parseInt(localStorage.getItem('token_expiresIn')) < currentTime) {
    //Logout user
    store.dispatch(logout());
    //Redirect to login
    window.location.href = "/login";
  }
}

// configureDatabase()
ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistStore(store)}>
      <Suspense fallback={<Spinner/>}>
        <Layout>
          <LazyApp/>
        </Layout>
      </Suspense>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
